"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _debounce = _interopRequireDefault(require("lodash/debounce"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _hammerjs = _interopRequireDefault(require("hammerjs"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
Entry.BlockView = /*#__PURE__*/function () {
  function BlockView(block, board, mode) {
    (0, _classCallCheck2["default"])(this, BlockView);
    (0, _defineProperty2["default"])(this, "schema", {
      id: 0,
      type: Entry.STATIC.BLOCK_RENDER_MODEL,
      x: 0,
      y: 0,
      offsetX: 0,
      offsetY: 0,
      width: 0,
      height: 0,
      contentWidth: 0,
      contentHeight: 0,
      topFieldHeight: 0,
      marginBottom: 0,
      magneting: false,
      visible: true,
      animating: false,
      shadow: true,
      display: true
    });
    (0, _defineProperty2["default"])(this, "_updateSchema", this._startContentRender);
    (0, _defineProperty2["default"])(this, "setHoverBlockView", this._setHoverBlockView);
    var that = this;
    Entry.Model(this, false);
    this.block = block;
    this._lazyUpdatePos = (0, _debounce["default"])(block._updatePos.bind(block), 200);
    this.mouseUpEvent = new Entry.Event(this);
    this.disableMouseEvent = false;
    this.dAlignContent = this.alignContent;
    this._board = board;
    this._observers = [];
    this.set(block);
    var hash = Entry.generateHash();
    this.svgGroup = board.svgBlockGroup.elem('g');
    this.svgGroup.attr('id', hash);
    this.svgGroup.blockView = this;
    if (block.isCommentable() && board.svgCommentGroup) {
      this.svgCommentGroup = board.svgCommentGroup.elem('g');
      this.svgCommentGroup.attr('id', "".concat(hash, "C"));
      this.svgCommentGroup.blockView = this;
    }
    this._schema = Entry.skinContainer.getSkin(block);
    if (this._schema === undefined) {
      this.block.destroy(false, false);
      return;
    }
    if (mode === undefined) {
      var workspace = this.getBoard().workspace;
      if (workspace && workspace.getBlockViewRenderMode) {
        this.renderMode = workspace.getBlockViewRenderMode();
      } else {
        this.renderMode = Entry.BlockView.RENDER_MODE_BLOCK;
      }
    } else {
      this.renderMode = Entry.BlockView.RENDER_MODE_BLOCK;
    }
    if (this._schema.deletable) {
      this.block.setDeletable(this._schema.deletable);
    }
    if (this._schema.copyable) {
      this.block.setCopyable(this._schema.copyable);
    }
    if (this._schema.display === false || block.display === false) {
      this.set({
        display: false
      });
    }
    this._skeleton = Entry.skeleton[this._schema.skeleton];
    var skeleton = this._skeleton;
    this._contents = [];
    this._statements = [];
    this._extensions = [];
    this.magnet = {};
    this._paramMap = {};
    if (skeleton.magnets && skeleton.magnets(this).next) {
      this.svgGroup.nextMagnet = this.block;
      this._nextGroup = this.svgGroup.elem('g');
      this._nextCommentGroup = this.svgCommentGroup && this.svgCommentGroup.elem('g');
      this._observers.push(this.observe(this, '_updateMagnet', ['contentHeight']));
    }
    this.isInBlockMenu = this.getBoard() instanceof Entry.BlockMenu;
    this.mouseHandler = function (e) {
      (_.result(that.block.events, 'mousedown') || []).forEach(function (fn) {
        if (Entry.documentMousedown) {
          Entry.documentMousedown.notify(e);
        }
        return fn(that);
      });
      that.onMouseDown.apply(that, arguments);
    };
    this._startRender(block, mode);

    // observe
    var thisBlock = this.block;
    this._observers.push(thisBlock.observe(this, '_setMovable', ['movable']));
    this._observers.push(thisBlock.observe(this, '_setReadOnly', ['movable']));
    this._observers.push(thisBlock.observe(this, '_setCopyable', ['copyable']));
    this._observers.push(thisBlock.observe(this, '_updateColor', ['deletable'], false));
    this._observers.push(this.observe(this, '_updateBG', ['magneting'], false));
    this._observers.push(this.observe(this, '_updateOpacity', ['visible'], false));
    this._observers.push(this.observe(this, '_updateDisplay', ['display']));
    this._observers.push(this.observe(this, '_updateMagnet', ['offsetY']));
    this._observers.push(board.code.observe(this, '_setBoard', ['board'], false));
    this.dragMode = Entry.DRAG_MODE_NONE;
    Entry.Utils.disableContextmenu(this.svgGroup.node);
    var events = block.events.viewAdd || [];
    if (Entry.type === 'workspace' && this._board instanceof Entry.Board) {
      events.forEach(function (fn) {
        if (_.isFunction(fn)) {
          fn(block);
        }
      });
    }
    this.onMouseMove = this.onMouseMove.bind(this);
    this.onMouseUp = this.onMouseUp.bind(this);
  }
  return (0, _createClass2["default"])(BlockView, [{
    key: "_startRender",
    value: function _startRender(block, mode) {
      var skeleton = this._skeleton;
      var attr = {
        "class": 'block'
      };
      if (this.display === false) {
        attr.display = 'none';
      }
      var svgGroup = this.svgGroup;
      svgGroup.attr(attr);
      (skeleton.classes || []).forEach(function (c) {
        return svgGroup.addClass(c);
      });
      var path = skeleton.path(this);
      this.pathGroup = svgGroup.prepend('g');
      this._updateMagnet();
      this._path = this.pathGroup.elem('path');
      var fillColor = this._schema.color;
      var _this$block = this.block,
        deletable = _this$block.deletable,
        emphasized = _this$block.emphasized;
      if (deletable === Entry.Block.DELETABLE_FALSE_LIGHTEN || emphasized) {
        fillColor = this._schema.emphasizedColor || Entry.Utils.getEmphasizeColor(fillColor);
      }
      this._fillColor = fillColor;
      var pathStyle = {
        d: path,
        fill: fillColor,
        "class": 'blockPath',
        blockId: this.id
      };
      var blockSchema = this._schema;
      var outerLine = blockSchema.outerLine;
      pathStyle.stroke = outerLine || skeleton.outerLine;
      pathStyle['stroke-linejoin'] = 'round';
      pathStyle['stroke-linecap'] = 'round';
      if (skeleton.stroke) {
        pathStyle['stroke-width'] = '1';
      }
      this._path.attr(pathStyle);
      this.moveTo(this.x, this.y, false);
      this._startContentRender(mode);
      this._startExtension(mode);
      if (this._board.disableMouseEvent !== true) {
        this._addControl();
      }
      var guide = this.guideSvgGroup;
      guide && svgGroup.insertBefore(guide, svgGroup.firstChild);
      this.bindPrev();
    }
  }, {
    key: "_startContentRender",
    value: function _startContentRender(mode) {
      var _this = this;
      mode = _.isUndefined(mode) ? this.renderMode : mode;
      var _removeFunc = _.partial(_.result, _, 'remove');
      _removeFunc(this.contentSvgGroup);
      _removeFunc(this.statementSvgGroup);
      if (this.statementCommentGroup) {
        _removeFunc(this.statementCommentGroup);
      }
      this.contentSvgGroup = this.svgGroup.elem('g');
      this._contents = [];
      var schema = this._schema;
      var statements = schema.statements;
      if (!_.isEmpty(statements)) {
        this.statementSvgGroup = this.svgGroup.elem('g');
        this.statementCommentGroup = this.svgCommentGroup && this.svgCommentGroup.elem('g');
      }
      var reg = /(%\d+)/im;
      var parsingReg = /%(\d+)/im;
      var parsingRet;
      var template = this._getTemplate(mode) || '';
      var params = this._getSchemaParams(mode);
      if (mode === Entry.BlockView.RENDER_MODE_TEXT) {
        if (/(if)+(.|\n)+(else)+/gim.test(template) && !reg.test(template) && this.isInBlockMenu) {
          template = template.replace('else', "%".concat(params.length, " else"));
        }
      }
      var _renderMode = mode || this.renderMode;
      template && template.split(reg).forEach(function (param, i) {
        var _param;
        if (param[0] === ' ') {
          param = param.substring(1);
        }
        if (param[param.length - 1] === ' ') {
          param = param.substring(0, param.length - 1);
        }
        if (!((_param = param) !== null && _param !== void 0 && _param.length)) {
          return;
        }
        parsingRet = parsingReg.exec(param);
        if (parsingRet) {
          var paramIndex = parsingRet[1] - 1;
          param = params[paramIndex];
          // params[paramIndex]= null||undefined 일 수 있는 경우에 대한 방어 코드
          if (!param) {
            return;
          }
          var field = new Entry["Field".concat(param.type)](param, _this, paramIndex, _renderMode, i);
          _this._contents.push(field);
          _this._paramMap[paramIndex] = field;
        } else {
          _this._contents.push(new Entry.FieldText({
            text: param,
            color: schema.fontColor
          }, _this));
        }
      });
      (schema.statements || []).forEach(function (s, i) {
        _this._statements.push(new Entry.FieldStatement(s, _this, i));
      });
      this.alignContent(false);
    }
  }, {
    key: "_startExtension",
    value: function _startExtension(mode) {
      var _this2 = this;
      this._extensions = this.block.extensions.map(function (e) {
        return new Entry["Ext".concat(e.type)](e, _this2, mode);
      });
    }
  }, {
    key: "changeType",
    value: function changeType(type) {
      this._schema = Entry.block[type || this.type];
      this._skeleton = Entry.skeleton[this._schema.skeleton];
      this._updateSchema();
    }
  }, {
    key: "alignContent",
    value: function alignContent(animate) {
      this.resetBackgroundPath();
      if (animate !== true) {
        animate = false;
      }
      var cursor = {
        x: 0,
        y: 0,
        height: 0
      };
      var statementIndex = 0;
      var width = 0;
      var secondLineHeight = 0;
      for (var i = 0; i < this._contents.length; i++) {
        var c = this._contents[i];
        if (c instanceof Entry.FieldLineBreak) {
          this._alignStatement(animate, statementIndex);
          c.align(statementIndex);
          statementIndex++;
          cursor.y = c.box.y;
          cursor.x = 8;
        } else {
          c.align(cursor.x, cursor.y, animate);
          // space between content
          if (i !== this._contents.length - 1 && !(c instanceof Entry.FieldText && c._text.length === 0)) {
            cursor.x += Entry.BlockView.PARAM_SPACE;
          }
        }
        var box = c.box;
        if (statementIndex !== 0) {
          secondLineHeight = Math.max(Math.round(box.height) * 1000000, secondLineHeight);
        } else {
          cursor.height = Math.max(box.height, cursor.height);
        }
        cursor.x += box.width;
        width = Math.max(width, cursor.x);
        if (this.contentWidth !== width || this.contentHeight !== cursor.height) {
          this.set({
            contentWidth: width,
            contentHeight: cursor.height
          });
        }
      }
      if (secondLineHeight) {
        this.set({
          contentHeight: cursor.height + secondLineHeight
        });
      }
      if (this._statements.length != statementIndex) {
        this._alignStatement(animate, statementIndex);
      }
      var contentPos = this.getContentPos();
      this.contentSvgGroup.attr('transform', "translate(".concat(contentPos.x, ",").concat(contentPos.y, ")"));
      this.contentPos = contentPos;
      this._render();
      var comment = this.block.comment;
      if (comment instanceof Entry.Comment) {
        comment.updateParentPos();
      }
      this._updateMagnet();
      var ws = this.getBoard().workspace;
      if (ws && (this.isFieldEditing() || ws.widgetUpdateEveryTime)) {
        ws.widgetUpdateEvent.notify();
      }
    }
  }, {
    key: "isFieldEditing",
    value: function isFieldEditing() {
      var contents = this._contents;
      for (var i = 0; i < contents.length; i++) {
        var content = contents[i] || {};
        if (content.isEditing && content.isEditing()) {
          return true;
        }
      }
      return false;
    }
  }, {
    key: "_alignStatement",
    value: function _alignStatement(animate, index) {
      var positions = this._skeleton.statementPos ? this._skeleton.statementPos(this) : [];
      var statement = this._statements[index];
      if (!statement) {
        return;
      }
      var pos = positions[index];
      if (pos) {
        statement.align(pos.x, pos.y, animate);
      }
    }
  }, {
    key: "_render",
    value: function _render() {
      this._renderPath();
      this.set(this._skeleton.box(this));
    }
  }, {
    key: "_renderPath",
    value: function _renderPath() {
      var newPath = this._skeleton.path(this);

      //no change occured
      if (this._path.getAttribute('d') === newPath) {
        return;
      }
      if (false && Entry.ANIMATION_DURATION !== 0) {
        var that = this;
        setTimeout(function () {
          that._path.animate({
            d: newPath
          }, Entry.ANIMATION_DURATION, mina.easeinout);
        }, 0);
      } else {
        this._path.attr({
          d: newPath
        });
        this.animating === true && this.set({
          animating: false
        });
      }
    }
  }, {
    key: "_setPosition",
    value: function _setPosition() {
      var board = this.getBoard();
      var _ref = board || {},
        _ref$scale = _ref.scale,
        scale = _ref$scale === void 0 ? 1 : _ref$scale;
      if (!(this.x || this.y)) {
        this.svgGroup.removeAttr('transform');
        this.svgCommentGroup && this.svgCommentGroup.removeAttr('transform');
      } else {
        var transform = "translate(".concat(this.x / scale, ",").concat(this.y / scale, ")");
        this.svgGroup.attr('transform', transform);
        this.svgCommentGroup && this.svgCommentGroup.attr('transform', transform);
      }
    }
  }, {
    key: "moveTo",
    value: function moveTo(x, y, animate, doNotUpdatePos) {
      var thisX = this.x;
      var thisY = this.y;
      if (!this.display) {
        x = -99999;
        y = -99999;
      }
      if (thisX !== x || thisY !== y) {
        this.set({
          x: x,
          y: y
        });
      }
      doNotUpdatePos !== true && this._lazyUpdatePos();
      if (this.visible && this.display) {
        this._setPosition(animate);
      }
    }
  }, {
    key: "moveBy",
    value: function moveBy(x, y, animate, doNotUpdatePos) {
      return this.moveTo(this.x + x, this.y + y, animate, doNotUpdatePos);
    }
  }, {
    key: "_addControl",
    value: function _addControl() {
      var _this3 = this;
      this._mouseEnable = true;
      var dblclick = _.result(this.block.events, 'dblclick');
      if (dblclick) {
        var hammer = new _hammerjs["default"](this.pathGroup);
        hammer.on('doubletap', function () {
          if (_this3._board.readOnly) {
            return;
          }
          dblclick.forEach(function (fn) {
            if (fn) {
              fn(_this3);
            }
          });
        });
        $(this.pathGroup).dblclick(function () {
          if (_this3._board.readOnly) {
            return;
          }
          dblclick.forEach(function (fn) {
            if (fn) {
              fn(_this3);
            }
          });
        });
      }
      $(this.svgGroup).bind('mousedown.blockViewMousedown touchstart.blockViewMousedown', this.mouseHandler);
    }
  }, {
    key: "removeControl",
    value: function removeControl() {
      this._mouseEnable = false;
      $(this.svgGroup).unbind('.blockViewMousedown');
    }
  }, {
    key: "setSelectedBlock",
    value: function setSelectedBlock(board) {
      var workspace = board.workspace;
      var selectedBlockView = workspace.selectedBlockView;
      var wsBoard = selectedBlockView ? selectedBlockView.getBoard() : board;
      if (board !== wsBoard) {
        wsBoard.setSelectedBlock(null);
      } else {
        board.setSelectedBlock(this);
      }
    }
  }, {
    key: "onMouseDown",
    value: function onMouseDown(e) {
      var _this4 = this;
      if (!this.isInBlockMenu && e.stopPropagation) {
        e.stopPropagation();
      }
      if (e.preventDefault) {
        e.preventDefault();
      }
      if (e.which == 2) {
        console.log('mouse wheel click disabled');
        return;
      }
      if (e.button == 1) {
        return;
      }
      if (Entry.disposeEvent) {
        Entry.disposeEvent.notify();
      }
      this.longPressTimer = null;
      var board = this.getBoard();
      if (board.workingEvent) {
        return;
      }
      if (this.readOnly || board.viewOnly) {
        return;
      }
      board.workingEvent = true;
      this.setSelectedBlock(board);

      //left mousedown
      if ((e.button === 0 || e.originalEvent && e.originalEvent.touches || e.touches) && !this._board.readOnly) {
        var eventType = e.type;
        var mouseEvent;
        if (e.originalEvent && e.originalEvent.touches) {
          mouseEvent = e.originalEvent.touches[0];
        } else if (e.touches) {
          mouseEvent = e.touches[0];
        } else {
          mouseEvent = e;
        }
        this.mouseDownCoordinate = {
          x: mouseEvent.pageX,
          y: mouseEvent.pageY
        };
        var $doc = $(document);
        if (!this.disableMouseEvent) {
          $doc.bind('mousemove.block', this.onMouseMove);
          document.addEventListener('touchmove', this.onMouseMove, {
            passive: false
          });
        }
        $doc.bind('mouseup.block', this.onMouseUp);
        document.addEventListener('touchend', this.onMouseUp);
        this.dragInstance = new Entry.DragInstance({
          startX: mouseEvent.pageX,
          startY: mouseEvent.pageY,
          offsetX: mouseEvent.pageX,
          offsetY: mouseEvent.pageY,
          height: 0,
          mode: true
        });
        board.set({
          dragBlock: this
        });
        this.addDragging();
        this.dragMode = Entry.DRAG_MODE_MOUSEDOWN;
        if (eventType === 'touchstart' || Entry.isMobile()) {
          this.longPressTimer = setTimeout(function () {
            if (_this4.longPressTimer) {
              _this4.longPressTimer = null;
              _this4.onMouseUp(e);
              _this4._rightClick(e, 'longPress');
            }
          }, 700);
        }
      } else if (Entry.Utils.isRightButton(e)) {
        this._rightClick(e);
      }
      if (board.workspace.getMode() === Entry.Workspace.MODE_VIMBOARD && e) {
        document.getElementsByClassName('CodeMirror')[0].dispatchEvent(Entry.Utils.createMouseEvent('dragStart', e));
      }
    }
  }, {
    key: "getVerticalMove",
    value: function getVerticalMove(mouseEvent, dragInstance) {
      var dx = Math.abs(mouseEvent.pageX - dragInstance.offsetX);
      var dy = Math.abs(mouseEvent.pageY - dragInstance.offsetY);
      return dy / dx > 1.75;
    }
  }, {
    key: "onMouseMove",
    value: function onMouseMove(e) {
      e.stopPropagation();
      e.preventDefault();
      var board = this.getBoard();
      var workspaceMode = board.workspace.getMode();
      var mouseEvent;
      if (workspaceMode === Entry.Workspace.MODE_VIMBOARD) {
        this.vimBoardEvent(e, 'dragOver');
      }
      if (e.originalEvent && e.originalEvent.touches) {
        mouseEvent = e.originalEvent.touches[0];
      } else if (e.touches) {
        mouseEvent = e.touches[0];
      } else {
        mouseEvent = e;
      }
      var mouseDownCoordinate = this.mouseDownCoordinate;
      var diff = Math.sqrt(Math.pow(mouseEvent.pageX - mouseDownCoordinate.x, 2) + Math.pow(mouseEvent.pageY - mouseDownCoordinate.y, 2));
      if (this.dragMode == Entry.DRAG_MODE_DRAG || diff > Entry.BlockView.DRAG_RADIUS) {
        var blockView = this;
        if (blockView.isInBlockMenu && this.longPressTimer && this.getVerticalMove(mouseEvent, blockView.dragInstance) || this.isVerticalMove) {
          this.isVerticalMove = true;
          return;
        } else {
          $(document).unbind('.blockMenu');
        }
        if (this.longPressTimer) {
          clearTimeout(this.longPressTimer);
          this.longPressTimer = null;
        }
        if (!this.movable) {
          return;
        }
        if (!this.isInBlockMenu) {
          var isFirst = false;
          if (this.dragMode != Entry.DRAG_MODE_DRAG) {
            this._toGlobalCoordinate(undefined, true);
            this.dragMode = Entry.DRAG_MODE_DRAG;
            this.block.getThread().changeEvent.notify();
            Entry.GlobalSvg.setView(this, workspaceMode);
            isFirst = true;
            this.fromBlockMenu = this.dragInstance && this.dragInstance.isNew;
          }
          if (this.animating) {
            this.set({
              animating: false
            });
          }
          if (this.dragInstance.height === 0) {
            var height = -1 + this.height;
            this.dragInstance.set({
              height: height
            });
          }
          var dragInstance = this.dragInstance;
          this.moveBy(mouseEvent.pageX - dragInstance.offsetX, mouseEvent.pageY - dragInstance.offsetY, false, true);
          Entry.GlobalSvg.position();
          dragInstance.set({
            offsetX: mouseEvent.pageX,
            offsetY: mouseEvent.pageY
          });
          if (!this.originPos) {
            this.originPos = {
              x: this.x,
              y: this.y
            };
          }
          if (isFirst) {
            board.generateCodeMagnetMap();
          }
          this._updateCloseBlock();
        } else {
          board.cloneToGlobal(e);
          // this.terminateEvent();
        }
      }
    }
  }, {
    key: "terminateEvent",
    value: function terminateEvent() {
      var $doc = $(document);
      document.removeEventListener('touchmove', this.onMouseMove, {
        passive: false
      });
      document.removeEventListener('touchend', this.onMouseUp);
      $doc.unbind('.block', this.onMouseUp);
      $doc.unbind('.block', this.onMouseMove);
    }
  }, {
    key: "onMouseUp",
    value: function onMouseUp(e) {
      if (e.which == 2) {
        console.log('mouse wheel click disabled');
        return;
      }
      if (e.button == 1) {
        return;
      }
      if (this.longPressTimer) {
        clearTimeout(this.longPressTimer);
        this.longPressTimer = null;
      }
      this.terminateEvent();
      this.terminateDrag(e);
      var board = this.getBoard();
      if (board) {
        board.set({
          dragBlock: null
        });
        delete board.workingEvent;
      }
      this._setHoverBlockView({
        that: this
      });
      Entry.GlobalSvg.remove();
      this.mouseUpEvent.notify();
      delete this.isVerticalMove;
      delete this.mouseDownCoordinate;
      delete this.dragInstance;
      delete this.magnetsOfThread;
    }
  }, {
    key: "vimBoardEvent",
    value: function vimBoardEvent(event, type, block) {
      if (!event) {
        return;
      }
      var dragEvent = Entry.Utils.createMouseEvent(type, event);
      if (block) {
        dragEvent.block = block;
      }
      $('.entryVimBoard>.CodeMirror')[0].dispatchEvent(dragEvent);
    }
  }, {
    key: "terminateDrag",
    value: function terminateDrag(e) {
      var gs = Entry.GlobalSvg;
      var board = this.getBoard();
      var dragMode = this.dragMode;
      var block = this.block;
      var workspaceMode = board.workspace.getMode();
      this.removeDragging();
      this.set({
        visible: true
      });
      this.dragMode = Entry.DRAG_MODE_NONE;
      var gsRet = gs.terminateDrag(this);
      if (workspaceMode === Entry.Workspace.MODE_VIMBOARD) {
        if (board instanceof Entry.BlockMenu) {
          board.terminateDrag();
          gsRet === gs.DONE && this.vimBoardEvent(e, 'dragEnd', block);
        } else {
          board.clear();
        }
      } else {
        var fromBlockMenu = this.dragInstance && this.dragInstance.isNew;
        if (dragMode === Entry.DRAG_MODE_DRAG) {
          var ripple = false;
          var prevBlock = this.block.getPrevBlock(this.block);
          var suffix = this._board.workspace.trashcan.isOver ? 'ForDestroy' : '';
          switch (gsRet) {
            case gs.DONE:
              {
                var closeBlock = board.magnetedBlockView;
                if (closeBlock instanceof Entry.BlockView) {
                  closeBlock = closeBlock.block;
                }
                if (prevBlock && !closeBlock) {
                  Entry["do"]("separateBlock".concat(suffix), block);
                } else if (!prevBlock && !closeBlock && !fromBlockMenu) {
                  if (!block.getThread().view.isGlobal()) {
                    Entry["do"]("separateBlock".concat(suffix), block);
                  } else {
                    Entry["do"]("moveBlock".concat(suffix), block);
                    this.dominate();
                  }
                } else {
                  suffix = fromBlockMenu ? 'FromBlockMenu' : '';
                  if (closeBlock) {
                    if (closeBlock.view.magneting === 'next') {
                      this.dragMode = dragMode;
                      var targetPointer = closeBlock.pointer();
                      targetPointer[3] = -1;
                      Entry["do"]("insertBlock".concat(suffix), block, targetPointer).isPass(fromBlockMenu);
                      Entry.ConnectionRipple.setView(closeBlock.view).dispose();
                      this.dragMode = Entry.DRAG_MODE_NONE;
                    } else {
                      if (closeBlock.getThread) {
                        var thread = closeBlock.getThread();
                        var closeBlockType = closeBlock.type;
                        if (closeBlockType && thread instanceof Entry.FieldBlock && !Entry.block[closeBlockType].isPrimitive) {
                          suffix += 'FollowSeparate';
                        }
                      }
                      Entry["do"]("insertBlock".concat(suffix), block, closeBlock).isPass(fromBlockMenu);
                      ripple = true;
                    }
                    Entry.Utils.playSound('entryMagneting');
                  } else {
                    Entry["do"]("moveBlock".concat(suffix), block).isPass(fromBlockMenu);
                    this.dominate();
                  }
                }
                break;
              }
            case gs.RETURN:
              {
                var _block = this.block;
                if (fromBlockMenu) {
                  Entry["do"]('destroyBlockBelow', this.block).isPass(true);
                } else {
                  if (prevBlock) {
                    this.set({
                      animating: false
                    });
                    Entry.Utils.playSound('entryMagneting');
                    this.bindPrev(prevBlock);
                    _block.insert(prevBlock);
                  } else {
                    var parent = _block.getThread().view.getParent();
                    if (!(parent instanceof Entry.Board)) {
                      Entry.Utils.playSound('entryMagneting');
                      Entry["do"]('insertBlock', _block, parent);
                    } else {
                      var originPos = this.originPos;
                      this.moveTo(originPos.x, originPos.y, false);
                      this.dominate();
                    }
                  }
                }
                break;
              }
            case gs.REMOVE:
              Entry.Utils.playSound('entryDelete');
              Entry["do"]('destroyBlockBelow', this.block).isPass(fromBlockMenu);
              break;
          }
          board.setMagnetedBlock(null);
          if (ripple) {
            Entry.ConnectionRipple.setView(block.view).dispose();
          }
        } else if (gsRet === gs.REMOVE && fromBlockMenu && dragMode === Entry.DRAG_MODE_MOUSEDOWN) {
          Entry["do"]('destroyBlockBelow', this.block).isPass(true);
        }
      }
      this.destroyShadow();
      delete this.originPos;
    }
  }, {
    key: "_getMagnetsInThread",
    value: function _getMagnetsInThread() {
      var _this$block$thread, _this$block$thread$ge, _lastBlock$view;
      var magnet = _objectSpread({}, this.magnet);
      var lastBlock = (_this$block$thread = this.block.thread) === null || _this$block$thread === void 0 || (_this$block$thread$ge = _this$block$thread.getLastBlock) === null || _this$block$thread$ge === void 0 ? void 0 : _this$block$thread$ge.call(_this$block$thread);
      var next = lastBlock === null || lastBlock === void 0 || (_lastBlock$view = lastBlock.view) === null || _lastBlock$view === void 0 || (_lastBlock$view = _lastBlock$view.magnet) === null || _lastBlock$view === void 0 ? void 0 : _lastBlock$view.next;
      if (next) {
        magnet.next = next;
      } else {
        delete magnet.next;
      }
      return magnet;
    }
  }, {
    key: "_updateCloseBlock",
    value: function _updateCloseBlock() {
      if (!this._skeleton.magnets) {
        return;
      }
      var board = this.getBoard();
      var _ref2 = board || {},
        _ref2$scale = _ref2.scale,
        scale = _ref2$scale === void 0 ? 1 : _ref2$scale;
      var x = this.x / scale;
      var y = this.y / scale;
      if (!this.magnetsOfThread) {
        this.magnetsOfThread = this._getMagnetsInThread();
      }
      for (var type in this.magnetsOfThread) {
        var view = _.result(board.getNearestMagnet(x, type === 'next' ? y + this.getBelowHeight() : y, type), 'view');
        if (view) {
          return board.setMagnetedBlock(view, type);
        }
      }
      board.setMagnetedBlock(null);
    }
  }, {
    key: "dominate",
    value: function dominate() {
      this.block.getThread().view.dominate();
      var board = this.getBoard();
      board.scroller.resizeScrollBar.call(board.scroller);
    }
  }, {
    key: "getSvgRoot",
    value: function getSvgRoot() {
      var svgBlockGroup = this.getBoard().svgBlockGroup;
      var node = this.svgGroup;
      while (node.parentNode !== svgBlockGroup) {
        node = node.parentNode;
      }
      return node;
    }
  }, {
    key: "getBoard",
    value: function getBoard() {
      return this._board;
    }
  }, {
    key: "getComment",
    value: function getComment() {
      return this.block.comment;
    }
  }, {
    key: "_setBoard",
    value: function _setBoard() {
      this._board = this._board.code.board;
    }
  }, {
    key: "destroy",
    value: function destroy(animate) {
      this.block.set({
        view: null
      });
      $(this.svgGroup).unbind('.blockViewMousedown');
      this._destroyObservers();
      var svgGroup = this.svgGroup;
      var _destroyFunc = _.partial(_.result, _, 'destroy');
      if (animate) {
        $(svgGroup).fadeOut(100, function () {
          return svgGroup.remove();
        });
      } else {
        svgGroup.remove();
      }
      this.svgCommentGroup && this.svgCommentGroup.remove();
      (this._contents || []).forEach(_destroyFunc);
      (this._statements || []).forEach(_destroyFunc);
      var block = this.block;
      if (Entry.type === 'workspace' && !this.isInBlockMenu) {
        (block.events.viewDestroy || []).forEach(function (fn) {
          if (_.isFunction(fn)) {
            var _block$thread;
            var notIncludeSelf = !!(block !== null && block !== void 0 && (_block$thread = block.thread) !== null && _block$thread !== void 0 && _block$thread.acceptType);
            fn(block, notIncludeSelf);
          }
        });
      }
    }
  }, {
    key: "getShadow",
    value: function getShadow() {
      if (!this._shadow) {
        this._shadow = Entry.SVG.createElement(this.svgGroup.cloneNode(true), {
          opacity: 0.5
        });
        this.getBoard().svgGroup.appendChild(this._shadow);
      }
      return this._shadow;
    }
  }, {
    key: "destroyShadow",
    value: function destroyShadow() {
      _.result(this._shadow, 'remove');
      delete this._shadow;
    }
  }, {
    key: "_updateMagnet",
    value: function _updateMagnet() {
      if (!this._skeleton.magnets) {
        return;
      }
      var magnet = this._skeleton.magnets(this);
      if (magnet.next) {
        this._nextGroup && this._nextGroup.attr('transform', "translate(".concat(magnet.next.x, ",").concat(magnet.next.y, ")"));
        this._nextCommentGroup && this._nextCommentGroup.attr('transform', "translate(".concat(magnet.next.x, ",").concat(magnet.next.y, ")"));
      }
      this.magnet = magnet;
      this.block.getThread().changeEvent.notify();
    }
  }, {
    key: "_updateBG",
    value: function _updateBG() {
      var dragBlock = this._board.dragBlock;
      if (!dragBlock || !dragBlock.dragInstance) {
        return;
      }
      var blockView = this;
      var svgGroup = blockView.svgGroup;
      if (!(this.magnet.next || this.magnet.previous)) {
        // field block
        if (this.magneting) {
          svgGroup.attr({
            filter: "url(#entryBlockHighlightFilter_".concat(this.getBoard().suffix, ")")
          });
          svgGroup.addClass('outputHighlight');
        } else {
          svgGroup.removeClass('outputHighlight');
          svgGroup.removeAttr('filter');
        }
        return;
      }
      var magneting = blockView.magneting;
      if (magneting) {
        var shadow = dragBlock.getShadow();
        var pos = this.getAbsoluteCoordinate();
        var magnet;
        var transform;
        if (magneting === 'previous') {
          magnet = this.magnet.next;
          transform = "translate(".concat(pos.scaleX + magnet.x, ",").concat(pos.scaleY + magnet.y, ")");
        } else if (magneting === 'next') {
          magnet = this.magnet.previous;
          var dragHeight = dragBlock.getBelowHeight();
          var nextX = (0, _get2["default"])(dragBlock, 'magnet.next.x');
          transform = "translate(".concat(pos.scaleX + magnet.x - nextX, ",").concat(pos.scaleY + magnet.y - dragHeight, ")");
        }
        var $shadow = $(shadow);
        $shadow.attr({
          transform: transform
        });
        $shadow.removeAttr('display');
        this._clonedShadow = shadow;
        if (blockView.background) {
          blockView.background.remove();
          blockView.nextBackground.remove();
          delete blockView.background;
          delete blockView.nextBackground;
        }
        if (magneting === 'previous' && dragBlock.block.thread instanceof Entry.Thread) {
          var height = dragBlock.getBelowHeight() + this.offsetY;
          blockView.originalHeight = blockView.offsetY;
          blockView.set({
            offsetY: height
          });
        }
      } else {
        if (this._clonedShadow) {
          this._clonedShadow.attr({
            display: 'none'
          });
          delete this._clonedShadow;
        }
        var _height = blockView.originalHeight;
        if (_height !== undefined) {
          if (blockView.background) {
            blockView.background.remove();
            blockView.nextBackground.remove();
            delete blockView.background;
            delete blockView.nextBackground;
          }
          blockView.set({
            offsetY: _height
          });
          delete blockView.originalHeight;
        }
      }
      _.result(blockView.block.thread.changeEvent, 'notify');
    }
  }, {
    key: "addDragging",
    value: function addDragging() {
      this.svgGroup.addClass('dragging');
      Entry.playground.setBackpackPointEvent(true);
    }
  }, {
    key: "removeDragging",
    value: function removeDragging() {
      this.svgGroup.removeClass('dragging');
      Entry.playground.setBackpackPointEvent(false);
    }
  }, {
    key: "addSelected",
    value: function addSelected() {
      var _document;
      (_document = document) === null || _document === void 0 || (_document = _document.activeElement) === null || _document === void 0 || _document.blur();
      $(this.pathGroup).insertAfter(this._nextGroup);
      this.svgGroup.removeClass('activated');
      this.svgGroup.addClass('selected');
    }
  }, {
    key: "removeSelected",
    value: function removeSelected() {
      $(this.pathGroup).insertBefore(this._nextGroup);
      this.svgGroup.removeClass('selected');
    }
  }, {
    key: "addActivated",
    value: function addActivated() {
      $(this.pathGroup).insertAfter(this._nextGroup);
      this.svgGroup.removeClass('selected');
      this.svgGroup.addClass('activated');
    }
  }, {
    key: "removeActivated",
    value: function removeActivated() {
      $(this.pathGroup).insertBefore(this._nextGroup);
      this.svgGroup.removeClass('activated');
    }
  }, {
    key: "getSkeleton",
    value: function getSkeleton() {
      return this._skeleton;
    }
  }, {
    key: "getContentPos",
    value: function getContentPos() {
      return this._skeleton.contentPos(this);
    }
  }, {
    key: "renderText",
    value: function renderText() {
      this.renderMode = Entry.BlockView.RENDER_MODE_TEXT;
      this._startContentRender(Entry.BlockView.RENDER_MODE_TEXT);
    }
  }, {
    key: "renderBlock",
    value: function renderBlock() {
      this.renderMode = Entry.BlockView.RENDER_MODE_BLOCK;
      this._startContentRender(Entry.BlockView.RENDER_MODE_BLOCK);
    }
  }, {
    key: "renderByMode",
    value: function renderByMode(mode, isReDraw) {
      if (this.isRenderMode(mode) && !isReDraw) {
        return;
      }
      this.renderMode = mode;
      this._startContentRender(mode);
    }
  }, {
    key: "_updateOpacity",
    value: function _updateOpacity() {
      if (this.visible === false) {
        this.svgGroup.attr({
          opacity: 0
        });
        this.svgCommentGroup && this.svgCommentGroup.attr({
          opacity: 0
        });
      } else {
        this.svgGroup.removeAttr('opacity');
        this.svgCommentGroup && this.svgCommentGroup.removeAttr('opacity');
        this._setPosition();
      }
    }
  }, {
    key: "_setMovable",
    value: function _setMovable() {
      if (this.block.isMovable() !== null) {
        this.movable = this.block.isMovable();
      } else if (this._skeleton.movable !== undefined) {
        this.movable = this._skeleton.movable;
      } else {
        this.movable = true;
      }
    }
  }, {
    key: "_setReadOnly",
    value: function _setReadOnly() {
      if (this.block.isReadOnly() !== null) {
        this.readOnly = this.block.isReadOnly();
      } else if (this._skeleton.readOnly !== undefined) {
        this.readOnly = this._skeleton.readOnly;
      } else {
        this.readOnly = false;
      }
    }
  }, {
    key: "_setCopyable",
    value: function _setCopyable() {
      if (this.block.isCopyable() !== null) {
        this.copyable = this.block.isCopyable();
      } else if (this._skeleton.copyable !== undefined) {
        this.copyable = this._skeleton.copyable;
      } else {
        this.copyable = true;
      }
    }
  }, {
    key: "bumpAway",
    value: function bumpAway() {
      var distance = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 15;
      var delay = arguments.length > 1 ? arguments[1] : undefined;
      var that = this;
      if (delay) {
        var oldX = this.x;
        var oldY = this.y;
        window.setTimeout(function () {
          //only when position not changed
          if (oldX === that.x && oldY === that.y) {
            that.moveBy(distance, distance, false);
          }
        }, delay);
      } else {
        that.moveBy(distance, distance, false);
      }
    }
  }, {
    key: "_toLocalCoordinate",
    value: function _toLocalCoordinate(view) {
      this.disableMouseEvent = false;
      this.moveTo(0, 0, false);
      var parentSvgGroup = view._nextGroup,
        parentCommentGroup = view._nextCommentGroup;
      parentSvgGroup && parentSvgGroup.appendChild && parentSvgGroup.appendChild(this.svgGroup);
      parentCommentGroup && parentCommentGroup.appendChild && parentCommentGroup.appendChild(this.svgCommentGroup);
    }
  }, {
    key: "_toGlobalCoordinate",
    value: function _toGlobalCoordinate(dragMode, doNotUpdatePos) {
      this.disableMouseEvent = false;
      var _this$getAbsoluteCoor = this.getAbsoluteCoordinate(dragMode),
        x = _this$getAbsoluteCoor.x,
        y = _this$getAbsoluteCoor.y;
      this.moveTo(x, y, false, doNotUpdatePos);
      this.getBoard().svgBlockGroup.appendChild(this.svgGroup);
      this.svgCommentGroup && this.getBoard().svgCommentGroup.appendChild(this.svgCommentGroup);
    }
  }, {
    key: "bindPrev",
    value: function bindPrev(prevBlock, isDestroy) {
      if (prevBlock) {
        this._toLocalCoordinate(prevBlock.view);
        var nextBlock = prevBlock.getNextBlock();
        if (nextBlock) {
          if (nextBlock && nextBlock !== this.block) {
            var endBlock = this.block.getLastBlock();
            if (isDestroy) {
              nextBlock.view._toLocalCoordinate(prevBlock.view);
            } else if (endBlock.view.magnet.next) {
              nextBlock.view._toLocalCoordinate(endBlock.view);
            } else {
              nextBlock.view._toGlobalCoordinate();
              nextBlock.separate();
              nextBlock.view.bumpAway(null, 100);
            }
          }
        }
      } else {
        prevBlock = this.block.getPrevBlock();
        if (prevBlock) {
          var prevBlockView = prevBlock.view;
          this._toLocalCoordinate(prevBlockView);
          var _nextBlock = this.block.getNextBlock();
          if (_nextBlock && _nextBlock.view) {
            _nextBlock.view._toLocalCoordinate(this);
          }
        }
      }
    }
  }, {
    key: "getAbsoluteCoordinate",
    value: function getAbsoluteCoordinate(dragMode) {
      var board = this.getBoard();
      var _ref3 = board || {},
        _ref3$scale = _ref3.scale,
        scale = _ref3$scale === void 0 ? 1 : _ref3$scale;
      dragMode = dragMode !== undefined ? dragMode : this.dragMode;
      if (dragMode === Entry.DRAG_MODE_DRAG) {
        return {
          x: this.x,
          y: this.y,
          scaleX: this.x / scale,
          scaleY: this.y / scale
        };
      }
      var pos = this.block.getThread().view.requestAbsoluteCoordinate(this);
      pos.x += this.x;
      pos.y += this.y;
      pos.scaleX = pos.x / scale;
      pos.scaleY = pos.y / scale;
      return pos;
    }
  }, {
    key: "getBelowHeight",
    value: function getBelowHeight() {
      return this.block.getThread().view.requestPartHeight(this);
    }
  }, {
    key: "_updateDisplay",
    value: function _updateDisplay() {
      if (this.display) {
        $(this.svgGroup).removeAttr('display');
        this._setPosition();
      } else {
        this.svgGroup.attr({
          display: 'none'
        });
      }
    }
  }, {
    key: "_updateColor",
    value: function _updateColor() {
      var fillColor = this._schema.color;
      var _this$block2 = this.block,
        deletable = _this$block2.deletable,
        emphasized = _this$block2.emphasized;
      if (deletable === Entry.Block.DELETABLE_FALSE_LIGHTEN || emphasized) {
        var emphasizedColor = this._schema.emphasizedColor;
        if (!emphasizedColor) {
          fillColor = Entry.Utils.getEmphasizeColor(fillColor);
        } else {
          fillColor = emphasizedColor;
        }
      }
      this._fillColor = fillColor;
      this._path.attr({
        fill: fillColor
      });
      this._updateContents();
    }
  }, {
    key: "_updateContents",
    value: function _updateContents(isReDraw) {
      var params = [undefined, undefined, this.renderMode, isReDraw];
      this._contents.forEach(function (c) {
        return c.renderStart.apply(c, params);
      });
      this.alignContent(false);
    }
  }, {
    key: "_destroyObservers",
    value: function _destroyObservers() {
      var observers = this._observers;
      while (observers.length) {
        observers.pop().destroy();
      }
    }
  }, {
    key: "reDraw",
    value: function reDraw() {
      if (!(this.visible && this.display)) {
        return;
      }
      this._updateContents(true);

      //해당 블럭이 가진 파라미터가 다른 블럭인 경우 재귀로 동작. indicator(undefined), string 은 제외
      (this.block.data.params || []).forEach(function (param) {
        if ((0, _get2["default"])(param, 'data.view')) {
          param.data.view.reDraw();
        }
      });
      (this.block.statements || []).forEach(function (_ref4) {
        var view = _ref4.view;
        return view.reDraw();
      });
      (this._extensions || []).forEach(function (ext) {
        return _.result(ext, 'updatePos');
      });
    }
  }, {
    key: "getParam",
    value: function getParam(index) {
      return this._paramMap[index];
    }
  }, {
    key: "getDataUrl",
    value: function getDataUrl(notClone, notPng) {
      var _this5 = this;
      return new Promise(function (resolve, reject) {
        var _this5$getBoard;
        var svgGroup = notClone ? _this5.svgGroup : _this5.svgGroup.cloneNode(true);
        var svgCommentGroup = notClone ? _this5.svgCommentGroup : _this5.svgCommentGroup && _this5.svgCommentGroup.cloneNode(true);
        if (!notClone) {
          svgGroup.removeAttribute('opacity');
          svgGroup.setAttribute('class', 'block selected');
        }
        var box = _this5._skeleton.box(_this5);
        var scale = ((_this5$getBoard = _this5.getBoard()) === null || _this5$getBoard === void 0 ? void 0 : _this5$getBoard.scale) || 1;
        var fontWeight = _this5.isWindow7() ? 0.9 : 0.95;
        if (_this5.type.indexOf('func_') > -1) {
          fontWeight *= 0.99;
        }
        svgGroup.setAttribute('transform', 'scale(%SCALE) translate(0,0)'.replace('%SCALE', scale));
        _this5.svgCommentGroup && svgCommentGroup.setAttribute('transform', 'scale(%SCALE) translate(0,0)'.replace('%SCALE', scale));
        var defs = _this5.getBoard().svgDom.find('defs');
        var images = svgGroup.getElementsByTagName('image');
        var texts = svgGroup.getElementsByTagName('text');
        var fontFamily = EntryStatic.getDefaultFontFamily();
        var boldTypes = ['≥', '≤'];
        var notResizeTypes = ['≥', '≤', '-', '>', '<', '=', '+', '-', 'x', '/'];
        _.toArray(texts).forEach(function (text) {
          text.setAttribute('font-family', fontFamily);
          var size = parseInt(text.getAttribute('font-size'), 10);
          var content = $(text).text();
          if (_.includes(boldTypes, content)) {
            text.setAttribute('font-weight', '500');
          }
          if (_.includes(notResizeTypes, content)) {
            text.setAttribute('font-size', "".concat(size, "px"));
          }
          text.setAttribute('alignment-baseline', 'auto');
        });
        if (images.length) {
          Array.from(images).forEach(function (image) {
            var href = image.getAttribute('href');
            image.setAttribute('href', "".concat(location.protocol, "//").concat(location.host).concat(href));
          });
        }
        _this5.processSvg(svgGroup, scale, defs, notPng).then(function (data) {
          resolve(data);
        })["catch"](function (err) {
          reject(err);
        });
      });
    }
  }, {
    key: "downloadAsImage",
    value: function () {
      var _downloadAsImage = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee(i) {
        var image;
        return _regenerator["default"].wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 1;
              return this.getDataUrl();
            case 1:
              image = _context.sent;
              Entry.dispatchEvent('saveBlockImages', {
                images: [image]
              });
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function downloadAsImage(_x) {
        return _downloadAsImage.apply(this, arguments);
      }
      return downloadAsImage;
    }()
  }, {
    key: "_rightClick",
    value: function _rightClick(e, eventSource) {
      var disposeEvent = Entry.disposeEvent;
      if (disposeEvent) {
        disposeEvent.notify(e);
      }
      var block = this.block;
      var board = this.getBoard();
      delete board.workingEvent;
      //if long pressed block is function_general block
      //edit function
      if (this.isInBlockMenu && eventSource === 'longPress' && block.getFuncId()) {
        return this._schema.events.dblclick[0](this);
      }
      var _Entry$Utils$convertM = Entry.Utils.convertMouseEvent(e),
        x = _Entry$Utils$convertM.clientX,
        y = _Entry$Utils$convertM.clientY;
      return Entry.ContextMenu.show(_getOptions(this), null, {
        x: x,
        y: y
      });

      //helper functon get get context options
      function _getOptions(blockView) {
        var isBoardReadOnly = blockView._board.readOnly;
        var block = blockView.block,
          isInBlockMenu = blockView.isInBlockMenu,
          copyable = blockView.copyable;
        var _Entry = Entry,
          _Entry$options = _Entry.options,
          EntryOptions = _Entry$options === void 0 ? {} : _Entry$options;
        var _Lang = Lang,
          _Lang$Blocks = _Lang.Blocks,
          AI_analyze_option = _Lang$Blocks.AI_analyze_option,
          Duplication_option = _Lang$Blocks.Duplication_option,
          CONTEXT_COPY_option = _Lang$Blocks.CONTEXT_COPY_option,
          cut_blocks = _Lang$Blocks.cut_blocks,
          Delete_Blocks = _Lang$Blocks.Delete_Blocks,
          save_as_image = _Lang.Menus.save_as_image;
        var aiAnalyze = {
          text: AI_analyze_option,
          enable: copyable && !isBoardReadOnly,
          callback: function callback() {
            // NOTICE : Entry.do는 필요할지 고려 > 뒤로가기 적용이 필요한지
            var blocksData = _objectSpread({}, block.copy());
            Entry.dispatchEvent('analyzeBlock', {
              data: JSON.stringify(blocksData)
            });
          }
        };
        var copyAndPaste = {
          text: Duplication_option,
          enable: copyable && !isBoardReadOnly,
          callback: function callback() {
            Entry["do"]('cloneBlock', block.copy());
          }
        };
        var copy = {
          text: CONTEXT_COPY_option,
          enable: copyable && !isBoardReadOnly,
          callback: function callback() {
            block.copyToClipboard();
          }
        };
        var cut = {
          text: cut_blocks,
          enable: copyable && block.isDeletable() && !isBoardReadOnly,
          callback: function callback() {
            block.copyToClipboard();
            Entry["do"]('destroyBlockBelow', block);
            blockView.getBoard().setSelectedBlock(null);
          }
        };
        var remove = {
          text: Delete_Blocks,
          enable: block.isDeletable() && !isBoardReadOnly,
          callback: function callback() {
            Entry["do"]('destroyBlock', block);
          }
        };
        var addStorage = !EntryOptions.backpackDisable && {
          text: Lang.Blocks.add_my_storage,
          enable: copyable && !isBoardReadOnly && !!window.user,
          callback: function callback() {
            Entry.dispatchEvent('addStorage', {
              type: 'block',
              data: block
            });
          }
        };
        var download = {
          text: save_as_image,
          callback: function callback() {
            blockView.downloadAsImage();
          }
        };
        var hasComment = !!block._comment;
        var comment = !EntryOptions.commentDisable && {
          text: hasComment ? Lang.Blocks.delete_comment : Lang.Blocks.add_comment,
          enable: block.isCommentable(),
          callback: function callback() {
            hasComment ? Entry["do"]('removeComment', block._comment) : Entry["do"]('createComment', {
              id: Entry.Utils.generateId()
            }, board, block);
          }
        };
        var options = [];
        if (_isDownloadable()) {
          options.push(download);
        }
        if (!isInBlockMenu) {
          options = [Entry.aiAssistantEnable && aiAnalyze, copyAndPaste, copy, cut, remove, addStorage].concat((0, _toConsumableArray2["default"])(options), [comment]).filter(function (x) {
            return x;
          });
        }
        return options;
        function _isDownloadable() {
          return Entry.blockSaveImageEnable && Entry.Utils.isChrome() && Entry.type === 'workspace' && !Entry.isMobile();
        }
      }
    }
  }, {
    key: "addStorage",
    value: function addStorage() {
      if (this.block.view) {
        Entry.dispatchEvent('addStorage', {
          type: 'block',
          data: this.block
        });
      }
    }
  }, {
    key: "clone",
    value: function clone() {
      return this.svgGroup.cloneNode(true);
    }
  }, {
    key: "setBackgroundPath",
    value: function setBackgroundPath() {
      var board = this.getBoard();
      if (board.dragBlock) {
        return;
      }
      this.resetBackgroundPath();
      var originPath = this._path;
      var clonedPath = originPath.cloneNode(true);
      clonedPath.setAttribute('class', 'blockBackgroundPath');
      clonedPath.setAttribute('fill', this._fillColor);
      this._backgroundPath = clonedPath;
      this.pathGroup.insertBefore(clonedPath, originPath);
      board.enablePattern();
      originPath.attr({
        fill: "url(#blockHoverPattern_".concat(board.suffix, ")")
      });
    }
  }, {
    key: "resetBackgroundPath",
    value: function resetBackgroundPath() {
      var board = this.getBoard();
      if (!this._backgroundPath || !board || !board.disablePattern) {
        return;
      }
      board.disablePattern();
      _.result($(this._backgroundPath), 'remove');
      this._backgroundPath = null;
      this._path.attr({
        fill: this._fillColor
      });
    }
  }, {
    key: "_getTemplate",
    value: function _getTemplate(renderMode) {
      var template;
      if (renderMode === Entry.BlockView.RENDER_MODE_TEXT) {
        var board = this.getBoard();
        var syntax;
        var workspace = board.workspace;
        if (workspace && workspace.vimBoard) {
          syntax = workspace.vimBoard.getBlockSyntax(this);
        } else {
          if (board.getBlockSyntax) {
            syntax = board.getBlockSyntax(this, renderMode);
          }
        }
        if (syntax) {
          if (typeof syntax === 'string') {
            template = syntax;
          } else {
            template = syntax.template;
          }
        }
      }
      return template || this._schema.template || Lang.template[this.block.type];
    }
  }, {
    key: "_getSchemaParams",
    value: function _getSchemaParams(mode) {
      var params = this._schema.params;
      if (mode === Entry.BlockView.RENDER_MODE_TEXT) {
        var workspace = this.getBoard().workspace;
        if (workspace && workspace.vimBoard) {
          var syntax = workspace.vimBoard.getBlockSyntax(this);
          if (syntax && syntax.textParams) {
            params = syntax.textParams;
          }
        }
      }
      return params;
    }
  }, {
    key: "detach",
    value: function detach() {
      this.svgGroup.remove();
    }
  }, {
    key: "attach",
    value: function attach(target) {
      (target || this._board.svgBlockGroup).appendChild(this.svgGroup);
    }
  }, {
    key: "getMagnet",
    value: function getMagnet(query) {
      var selector = query.shift() || 'next';
      var halfWidth = query.shift();
      if (halfWidth === undefined) {
        halfWidth = 20;
      }
      return {
        getBoundingClientRect: function () {
          var coord = this.getAbsoluteCoordinate();
          var boardOffset = this._board.relativeOffset;
          var magnet = this.magnet[selector];
          return {
            top: coord.y + boardOffset.top + magnet.y - halfWidth,
            left: coord.x + boardOffset.left + magnet.x - halfWidth,
            width: 2 * halfWidth,
            height: 2 * halfWidth
          };
        }.bind(this)
      };
    }
  }, {
    key: "isRenderMode",
    value: function isRenderMode(mode) {
      return this.renderMode === mode;
    }
  }, {
    key: "_setHoverBlockView",
    value: function _setHoverBlockView(data) {
      if (!data) {
        return;
      }
      var that = data.that,
        blockView = data.blockView;
      var target = _.result(that.getBoard(), 'workspace');
      if (!target) {
        return;
      }
      target.setHoverBlockView(blockView);
    }
  }, {
    key: "getFields",
    value: function getFields() {
      if (!this._schema) {
        return [];
      }
      var THREAD = Entry.Thread;
      var FIELD_BLOCK = Entry.FieldBlock;
      var FIELD_OUTPUT = Entry.FieldOutput;
      return (this._statements || []).reduce(function (fields, statement) {
        statement = statement && statement._thread;
        if (!(statement instanceof THREAD)) {
          return fields;
        }
        return fields.concat(statement.view.getFields());
      }, (this._contents || []).reduce(function (fields, c) {
        if (!c) {
          return fields;
        }
        fields.push(c);
        if (c instanceof FIELD_BLOCK || c instanceof FIELD_OUTPUT) {
          //some output block doesn't have value block
          var valueBlock = c.getValueBlock && c.getValueBlock();
          if (!valueBlock) {
            return fields;
          }
          fields = fields.concat(valueBlock.view.getFields());
        }
        return fields;
      }, []));
    }
  }, {
    key: "processSvg",
    value: function processSvg(svgGroup) {
      var _this6 = this;
      var scale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
      var defs = arguments.length > 2 ? arguments[2] : undefined;
      return new Promise(function (resolve, reject) {
        var svgData = '<?xml version="1.0" encoding="UTF-8" standalone="yes"?><svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 %W %H">(svgGroup)(defs)</svg>';
        var bBox = _this6.svgGroup.getBoundingClientRect();
        var boxWidth = bBox.width;
        var boxHeight = bBox.height;
        var offset = 2 * scale;
        svgData = svgData.replace('(svgGroup)', new XMLSerializer().serializeToString(svgGroup)).replace('%W', Math.ceil(boxWidth) + offset).replace('%H', Math.ceil(boxHeight) + offset).replace('(defs)', new XMLSerializer().serializeToString(defs[0])).replace(/>\s+/g, '>').replace(/\s+</g, '<');
        svgData = svgData.replace(/NS\d+:href/gi, 'href');
        var data = Entry.isOffline ? "data:image/svg+xml;base64,".concat(btoa(unescape(encodeURIComponent(svgData)))) : svgData;
        resolve({
          width: boxWidth,
          height: boxHeight,
          data: data
        });
      });
    }
  }, {
    key: "loadImage",
    value: function loadImage(src, width, height, notPng) {
      var multiplier = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 1;
      return new Promise(function (resolve, reject) {
        if (Entry.BlockView.pngMap[src] !== undefined) {
          return resolve(Entry.BlockView.pngMap[src]);
        }
        if (notPng) {
          return resolve("".concat(location.origin).concat(src));
        }
        width *= multiplier;
        height *= multiplier;
        //float point cropped
        width = Math.ceil(width);
        height = Math.ceil(height);
        var img = document.createElement('img');
        img.crossOrigin = 'Anonymous';
        var canvas = document.createElement('canvas');
        canvas.width = width;
        canvas.height = height;
        var ctx = canvas.getContext('2d');
        img.onload = function () {
          try {
            ctx.drawImage(img, 0, 0, width, height);
            var data = canvas.toDataURL('image/png');
            if (/\.png$/.test(src)) {
              Entry.BlockView.pngMap[src] = data;
            }
            return resolve(data);
          } catch (e) {
            return reject('error occured');
          }
        };
        img.onerror = function () {
          return reject('error occured');
        };
        img.src = src;
      });
    }
  }, {
    key: "isWindow7",
    value: function isWindow7() {
      var platform = window.platform;
      if (platform && platform.name.toLowerCase() === 'windows' && platform.version[0] === '7') {
        return true;
      }
      return false;
    }
  }]);
}();
Entry.BlockView.PARAM_SPACE = 7;
Entry.BlockView.DRAG_RADIUS = 5;
Entry.BlockView.pngMap = {};
Entry.BlockView.RENDER_MODE_BLOCK = 1;
Entry.BlockView.RENDER_MODE_TEXT = 2;